<template>
  <div class="bordered padding-30 rounded news-list" v-if="item.length > 0">
    <div class="news-block" v-for="(item, index) in item" :key="index">
      <div class="image" @click="article(item.id)" style="cursor: pointer;">
        <img :src="item.image_url" :alt="applicationLocale === 'en' ? item.title_en : item.title" />
      </div>
      <div class="text">
        <div class="date">
          <div>{{ item.created_at }}</div>
          <div style="display: flex; align-items: center;">
            <div class="tag" @click="category(item.type_to.id)" style="cursor: pointer;">
              {{ applicationLocale === 'en' ? item.type_to.name_en : item.type_to.name }}
            </div>
          </div>
        </div>
        <h3 class="title column-2" @click="article(item.id)" style="cursor: pointer;">
          {{ applicationLocale === 'en' ? item.title_en : item.title }}
        </h3>
        <div class="desc">{{ applicationLocale === 'en' ? item.description_en : item.description }}</div>
      </div>
    </div>
  </div>
  <div v-else style="text-align: center; color: #8F9BAD !important;" class="bordered padding-30 rounded news-list">
    {{ noDataText }}
  </div>
</template>

<script>
import { h } from 'vue';

export default {
  name: 'Latest',
  props: {
    item: {
      type: Array,
      default: () => []
    },
    applicationLocale: {
      type: String,
      default: ''
    },
    noDataText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    handleImageError(item) {
      // 处理图片显示错误
    },
    article(id) {
      this.$router.push({ path: '/pages/news/article', query: { id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') console.error(err)
      })
    },
    category(id) {
      this.$router.push({ path: '/pages/news/category', query: { id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') console.error(err)
      })
    }
  }
}
</script>

<style>
@import '../../public/static/css/index.css';
</style>
